import { createActionGroup, emptyProps, props } from '@ngrx/store';
import * as fromGenerated from '../../../_generated';

export const AssistantsActions = createActionGroup({
  source: 'Assistants',
  events: {
    'Load Assistants': emptyProps(),
    'Load Assistants Success': props<{
      assistants: fromGenerated.AssistantView[];
    }>(),
    'Load Assistants Failure': props<{ error: string }>(),
  },
});

/**
 * SB-3325 PR-4 (Stage B): the skill builder is a modal overlay opened over the
 * assistants list (mirrors the teammate builder), not a route. These actions
 * drive its open/close state.
 *
 * `Open Edit` carries the full `AssistantView` snapshot captured at click time
 * (not just the uuid). The old routed builder took a one-time resolver snapshot
 * (`take(1)`); the modal must preserve that semantics. Reading the edit target
 * live from the loaded entities let any background `loadAssistants` reload
 * (socket `SkillsUpdated`/`TeammatesUpdated`/reconnect → `setAll`, new refs)
 * re-fire the builder's patch/reset/share-seed effects mid-edit — clobbering
 * unsaved work, or dropping the entity entirely and pushing Save onto the CREATE
 * branch (duplicate). Snapshotting here keeps `[assistant]` stable and defined
 * for the modal's whole lifetime.
 */
export const AssistantBuilderModalActions = createActionGroup({
  source: 'Assistant Builder Modal',
  events: {
    'Open Create': emptyProps(),
    'Open Edit': props<{ assistant: fromGenerated.AssistantView }>(),
    Close: emptyProps(),
  },
});

export const AssistantActions = createActionGroup({
  source: 'Assistant',
  events: {
    'Select Assistant': props<{ uuid: string }>(),
    'Unselect Assistant': emptyProps(),
    'Received Assistant Status Updated From Socket': props<{
      uuid: fromGenerated.AssistantView['uuid'];
      status: fromGenerated.AssistantView['status'];
      documents: fromGenerated.AssistantView['documents'];
    }>(),
    'Duplicate Assistant': props<{ uuid: string }>(),
    'Duplicate Assistant Success': props<{
      assistant: fromGenerated.AssistantView;
    }>(),
    'Duplicate Assistant Failure': props<{ error: string }>(),
    'Delete Assistant': props<{
      uuid: string;
    }>(),
    'Delete Assistant Success': props<{
      uuid: string;
    }>(),
    'Delete Assistant Failure': props<{
      error: string;
    }>(),
  },
});
